import * as React from 'react';

const OutlookIcon$2 = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#158FDA",
        d: "M6.58 17.2h10.25c1.2 0 2.17-.97 2.17-2.17V7.7c0-.64-.32-1.22-.87-1.54L12.77 3.1c-.72-.4-1.6-.4-2.3 0L4.39 6.6V15c0 1.21.98 2.2 2.2 2.2"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#b)",
        d: "M8.61 15.82c.06-.66.48-1.24 1.09-1.5 0 0 5.55-3.11 8.3-4.73.85-.5 1-1.5 1-1.5V15a2.2 2.2 0 0 1-2.2 2.2h-6.65c-.8 0-1.46-.6-1.54-1.4"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#01459B",
        d: "m17.83 5.96-9.55 5.27 1.9 1.16c.71.42 1.74.66 2.46.25l5.08-2.85A2.3 2.3 0 0 0 19 7.69c0-1.1-.76-1.47-1.17-1.73"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#26AEE9",
        d: "M11.67 2.81q-.63 0-1.21.32L2.4 7.68l3.06 1.85 9.37-5.28-1.95-1.11q-.57-.33-1.2-.33"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#0078D3",
        d: "M14.83 4.25 5.46 9.53l3.06 1.86 9.56-5.27-.25-.16z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#c)",
        d: "M1.88 5.42h7.5a.74.74 0 0 1 .75.74l-.03 7.32a.76.76 0 0 1-.76.76H1.9a.8.8 0 0 1-.78-.78l.03-7.33a.7.7 0 0 1 .72-.71"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#d)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#e)",
        d: "M1.88 5.42h7.5a.74.74 0 0 1 .75.74l-.03 7.32a.76.76 0 0 1-.76.76H1.9a.8.8 0 0 1-.78-.78l.03-7.33a.7.7 0 0 1 .72-.71"
    })), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M3.46 8.58q.28-.6.84-.94.64-.36 1.36-.36.69-.02 1.27.3.56.3.85.87.32.6.32 1.3.02.7-.28 1.36a2.2 2.2 0 0 1-1.1 1.06q-.52.21-1.05.21-.7.03-1.3-.3-.57-.3-.86-.87-.32-.6-.32-1.28-.02-.7.27-1.35m.95 2.15q.16.37.5.6t.75.21q.45 0 .8-.24.33-.24.47-.62.15-.41.13-.85 0-.44-.15-.85a1.4 1.4 0 0 0-.47-.63 1.3 1.3 0 0 0-.8-.23 1.3 1.3 0 0 0-1.25.86c-.22.57-.2 1.2.02 1.75"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "b",
        x1: 12.02,
        x2: 19,
        y1: 15.58,
        y2: 12.64,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#4DE2FB"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#28AEE8"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "c",
        x1: 5.63,
        x2: 5.62,
        y1: 5.42,
        y2: 14.24,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1582D8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0A64CC"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "e",
        x1: 5.63,
        x2: 5.62,
        y1: 5.42,
        y2: 14.24,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#1582D8"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0A64CC"
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h20v20H0z"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "d",
        width: 53.58,
        height: 53.4,
        x: -15.16,
        y: -10.87,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dx: 6,
        dy: 6
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: 11.14
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "out"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.38 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_893_1954"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_893_1954",
        result: "shape"
    }))));

export { OutlookIcon$2 as OutlookIcon };
//# sourceMappingURL=Outlook.mjs.map
